// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yQ-z","hovered":"zQ-z","hoverImage":"AQ-z","mainImage":"BQ-z","imageNoBackground":"CQ-z","fullSizeImage":"DQ-z"};